import Helmet from '@components/Helmet/Helmet';
import LoadingComponent from '@components/Loading/Loading.component';
import { PrivateRoute } from '@components/PrivateRoute/PrivateRoute';
import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import GiayBao from './pages/GiayBao/GiayBao';
import UserHome from './pages/UserHome/UserHome';

const Login = lazy(() => import('./pages/Login/Login'));
const GuestHome = lazy(() => import('./pages/GuestHome/GuestHome'));
// const PageOne = lazy(() => import('./pages/PageOne/PageOne'));

// const Countdown = lazy(() => import('./pages/CountDown/Countdown'));

function App() {
  return (
    <Suspense fallback={<></>}>
      <Helmet title="VWSCO"></Helmet>
      <BrowserRouter>
        {/* <Header /> */}
        <LoadingComponent />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/user"
            element={
              <PrivateRoute>
                <UserHome />
              </PrivateRoute>
            }
          />
          <Route path="/guest" element={<GuestHome />} />
          <Route path="/giaybao/:userId" element={<GiayBao />} />
          {/* <Route path="maduthuong" element={<PageOne />} />
          <Route path="countdown" element={<Countdown />} /> */}
        </Routes>
        {/* <Footer /> */}
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
